import styled from "styled-components";
import BoxMainHeader from "./BoxMainHeader";
import SectionHeaderAndContent from "../../components/SectionHeaderAndContent";

const ProfileSectionHeaderValue = ({
  boxMainHeader,
  templateColumnsForBiggerScreens = "2",
  data,
}) => {
  return (
    <>
      <BoxMainHeader header={boxMainHeader} />
      <BoxHeaderWrapper
        templateColumnsForBiggerScreens={templateColumnsForBiggerScreens}
      >
        {Object.entries(data).map(([key, val], ind) => (
          <SectionHeaderAndContent key={ind + 1} heading={key} content={val} />
        ))}
      </BoxHeaderWrapper>
    </>
  );
};

const BoxHeaderWrapper = styled.div`
  padding-top: 1.125rem;
  display: grid;
  grid-template-columns: repeat(
    ${(props) => props.templateColumnsForBiggerScreens},
    1fr
  );
  gap: 2.875rem 2.875rem;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 481px) and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 1rem;
  }
`;

export default ProfileSectionHeaderValue;
